import React, { Component } from 'react';
import { Row, Col } from 'reactstrap'

import styles from './BookingModal.css'
import { faCalendarAlt, faMapMarkerAlt } from "@fortawesome/pro-light-svg-icons/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index.es";
import Button from "../Button/Button";
import Input from "../Input/Input";
import moment from "moment/moment";

export default class BookingModal extends Component {
  state = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
    privat: false,
    firstNameError: false,
    lastNameError: false,
    emailError: false,
    phoneError: false,
  }

  constructor(props) {
    super(props);

    this.validateField = this.validateField.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  validateField(name) {
    if (this.state[name] === "") {
      this.setState({
        [name + 'Error']: true
      })

      return false;
    }

    this.setState({
      [name + 'Error']: false
    })

    return true;
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleFormSubmit(e) {
    e.preventDefault();
    const { submitAction } = this.props;
    const { firstName, lastName, email, phone, privat } = this.state;

    let errors = false;

    if (!this.validateField('firstName')) errors = true;
    if (!this.validateField('lastName')) errors = true;
    if (!this.validateField('email')) errors = true;
    if (!this.validateField('phone')) errors = true;

    if (errors) {
      return false;
    }

    submitAction({
      firstname: firstName,
      lastname: lastName,
      email: email,
      phone: phone,
      privat: privat
    });

  }

  render() {

    const { firstName, lastName, email, phone, message, firstNameError, lastNameError, emailError, phoneError } = this.state;
    const { appointment } = this.props;

    return (
      <div className={styles.content}>
        <h3>Termin buchen</h3>

        <div className={styles.detail}>

          <div className={styles.infoWrapper}>
            <div className={styles.info}>
                            <span className={styles.label}>
                                <FontAwesomeIcon icon={faCalendarAlt} size="lg" />
                                Wann?
                            </span>
              {moment(appointment.date).format('DD.MM.YYYY')}
              <br />
              {moment(appointment.date).format('HH:mm')} Uhr
            </div>

            <div className={[styles.info, styles.last].join(' ')}>
                            <span className={styles.label}>
                                <FontAwesomeIcon icon={faMapMarkerAlt} size="lg" />
                                Wo?
                            </span>
              {appointment.street} {appointment.housenumber}<br />{appointment.plz} {appointment.city}
            </div>
          </div>

          <hr />

          <form className={styles.form} onSubmit={this.handleFormSubmit}>

            <Row>
              <Col xs={12} md={6}>
                <Input
                  type="text"
                  name="firstName"
                  placeholder="Vorname*"
                  autocomplete="off"
                  value={firstName}
                  error={firstNameError}
                  onChange={this.handleInputChange}
                />
              </Col>

              <Col xs={12} md={6}>
                <Input
                  type="text"
                  name="lastName"
                  placeholder="Nachname*"
                  autocomplete="off"
                  value={lastName}
                  error={lastNameError}
                  onChange={this.handleInputChange}
                />
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={6}>
                <Input
                  type="text"
                  name="email"
                  placeholder="E-Mail-Adresse*"
                  autocomplete="off"
                  value={email}
                  error={emailError}
                  onChange={this.handleInputChange}
                />
              </Col>

              <Col xs={12} md={6}>
                <Input
                  type="text"
                  name="phone"
                  placeholder="Telefon*"
                  autocomplete="off"
                  value={phone}
                  error={phoneError}
                  onChange={this.handleInputChange}
                />
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={12}>
                <Input
                  type="textarea"
                  name="message"
                  placeholder="Möchten Sie Ihrem Arzt noch etwas mitteilen? Dieses Freitextfeld ist jedoch nicht für gesundheitsrelevante Daten bestimmt."
                  autocomplete="off"
                  value={message}
                  onChange={this.handleInputChange}
                />
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={12}>
                <label style={{marginBottom: '40px'}}>
                  <input
                    type="checkbox"
                    className={styles.checkbox}
                    style={{marginRight: '5px'}}
                    onChange={(event) => this.setState({ privat: event.target.checked })}
                  /> Ich bin Privatpatient
                </label>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={6}>
                <p>* Angaben sind verpflichtend</p>
              </Col>
              <Col xs={12} md={6}>
                <Button submit pullRight>Termin buchen</Button>
              </Col>
            </Row>


          </form>

        </div>
      </div>
    )
  }
}
/*
<FormGroup className={[styles.input, styles.formGroup, lastNameError ? styles.error : ""].join(' ')}>
                            <Input type="text" name="lastName" id="lastName" placeholder="Nachname*" autocomplete="off" value={lastName} onChange={this.handleInputChange} />
                        </FormGroup>

                        <FormGroup className={[styles.input, styles.formGroup, emailError ? styles.error : ""].join(' ')}>
                            <Input type="email" name="email" id="email" placeholder="E-Mail-Adresse*" autocomplete="off" value={email} onChange={this.handleInputChange} />
                        </FormGroup>

                        <FormGroup className={[styles.input, styles.formGroup].join(' ')}>
                            <Input type="phone" name="phone" id="phone" placeholder="Telefon" autocomplete="off" value={phone} onChange={this.handleInputChange} />
                        </FormGroup>
 */



// WEBPACK FOOTER //
// ./src/components/BookingModal/BookingModal.js